import React, { useContext, useEffect, useState } from 'react';
import { CirclePicker, ChromePicker } from 'react-color';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import { useTranslation } from 'react-i18next';
import './ColorPicker.css';
import _ from 'lodash';

const defaultColors = [
  '#FFFFFF',
  '#000000',
  '#4D4D4D',
  '#999999',
  '#F44E3B',
  '#FE9200',
  '#FCDC00',
  '#DBDF00',
  '#A4DD00',
  '#68CCCA',
  '#73D8FF',
  '#AEA1FF',
  '#FDA1FF',
  '#333333',
  '#808080',
  '#cccccc',
  '#D33115',
  '#E27300',
  '#FCC400',
  '#B0BC00',
  '#68BC00',
  '#16A5A5',
  '#009CE0',
  '#7B64FF',
  '#FA28FF',
  '#666666',
  '#B3B3B3',
  '#9F0500',
  '#C45100',
  '#FB9E00',
  '#808900',
  '#194D33',
  '#0C797D',
  '#0062B1',
  '#653294',
  '#AB149E',
];

const ColorPicker = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { activePageRef } = useContext(DesignContext);
  const currentPage = useSelector(state => state.design.pages[activePageRef.current]);
  const colorPickerColor = useSelector(state => state.design.colorPickerColor);
  const imagesColors = useSelector(state => state.design.imageColorsState);
  const entitiesState = useSelector(state => state.design.entitiesState);
  const svgState = useSelector(state => state.design.svgsState);
  const [designColors, setDesignColors] = useState()
  const [pageImagesColors, setPageImagesColors] = useState()

  const rgb2hex = (rgb) => {
    var rgbColor = rgb.split("(")[1].split(")")[0];
    rgbColor = rgbColor.split(",");
    var b = rgbColor.map(function (x) {             //For each array element
      x = parseInt(x).toString(16);      //Convert to a base16 string
      return (x.length == 1) ? "0" + x : x;  //Add zero if we get only one character
    })
    return "#" + b.join("");;
  }

  useEffect(() => {
    const colors = [];
    const imgColors = [];
    const backgroundColor = _.get(currentPage, 'background.color');
    if (backgroundColor) colors.push(backgroundColor);
    const entities = _.get(currentPage, 'entities')
    entities.map(entity => {
      if (entity.type === 'Vector' || entity.type === 'Shape') {
        svgState[entity.id].map(svg => {
          let fill = svg.fill;
          let stroke = svg.stroke;
          if (fill && fill.includes('rgb')) fill = rgb2hex(fill)
          if (stroke && stroke.includes('rgb')) stroke = rgb2hex(stroke)
          fill && colors.push(fill);
          stroke && colors.push(stroke);
        })
      } else if (entity.type === 'Text') {
        const textElement = document.getElementById(`ET_${entity.id}`);
        const textSpans = textElement.querySelectorAll('span');
        [...textSpans].map(span => {
          let spanColor = _.get(span, 'style.color');
          if (spanColor) {
            spanColor = rgb2hex(spanColor)
            colors.push(spanColor)
          }
        })
      } else if (entity.type === 'Image') {
        const existSrc = _.find(imagesColors, { url: entitiesState[entity.id].src });
        existSrc && imgColors.push(existSrc)
      }

    })
    setPageImagesColors(imgColors)
    setDesignColors(_.uniq(colors));
  }, [currentPage])
  const handleChangeComplete = color => {
    dispatch(designActions.changeColorPickerColor(color.hex));
  };
  const handleClose = () => {
    dispatch(designActions.setSidePanel(null));
  };

  return (
    <>
      <div className="panelsCloseStrip" onClick={handleClose}></div>
      <div className="colorPickerHolder">
        <div className="header">
          <span className="closeIcon btn left" onClick={handleClose}></span>
        </div>
        <div className="content">
          <ChromePicker
            color={colorPickerColor}
            disableAlpha={true}
            onChangeComplete={handleChangeComplete}
          />
          {(imagesColors && imagesColors.length > 0) &&
            <div className="imagesColorsBox">
              <span className="colorsTitle">{t('photoColors')}</span>
              {pageImagesColors && pageImagesColors.map(image => {
                return (
                  <div className="imageColorsHolder">
                    <img className="imageSample" src={image.url} style={{ width: '28px', height: '28px' }} />
                    <CirclePicker colors={image.colors} onChangeComplete={handleChangeComplete} />
                  </div>
                )
              })}
            </div>
          }
          {(designColors && designColors.length > 0) &&
            <div className="designColorsBox">
              <span className="colorsTitle">{t('pageColors')}</span>
              <div className="designColorsHolder">
                {/* <img className="imageSample" src={image.url} style={{ width: '28px', height: '28px' }} /> */}
                <CirclePicker colors={designColors} onChangeComplete={handleChangeComplete} />
              </div>
            </div>
          }
          {(imagesColors || (designColors && designColors.length > 0)) &&
            <span className="colorsTitle">{t('defaultColors')}</span>
          }
          <CirclePicker colors={defaultColors} onChangeComplete={handleChangeComplete} />
        </div>
      </div>
    </>
  );
};

export default ColorPicker;
